import { createRouter, createWebHashHistory } from 'vue-router';

import common from './modules/common';
import policeSituation from './modules/policeSituation';

const routes = [...common, ...policeSituation];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
